import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M6.502 3.292a2.291 2.291 0 1 1 4.582-.001 2.291 2.291 0 0 1-4.582 0m-.26 6.14c1.382-1.417 3.722-1.417 5.103 0a.914.914 0 0 0 1.297.016.917.917 0 0 0 .016-1.296C11.618 7.086 10.246 6.5 8.793 6.5c-1.452 0-2.825.586-3.864 1.652a.916.916 0 1 0 1.313 1.28m16.06 3.498-6.238 7A9.18 9.18 0 0 1 9.22 23H4.669a3.67 3.67 0 0 1-3.667-3.667V14.75a3.67 3.67 0 0 1 3.667-3.667h8.118c1.045 0 1.961.558 2.465 1.393l2.949-3.24a2.74 2.74 0 0 1 1.911-.9 2.78 2.78 0 0 1 1.988.718 2.77 2.77 0 0 1 .2 3.877zm-1.435-2.523a.9.9 0 0 0-.668-.24.92.92 0 0 0-.641.301l-4.057 4.46a2.9 2.9 0 0 1-2.305 1.886l-4.73.676a.918.918 0 0 1-.26-1.816l4.73-.676a1.05 1.05 0 0 0 .9-1.036 1.05 1.05 0 0 0-1.049-1.047H4.67a1.835 1.835 0 0 0-1.834 1.833v4.583c0 1.011.822 1.833 1.834 1.833h4.55c2.09 0 4.085-.895 5.477-2.454l6.237-7.002a.93.93 0 0 0-.066-1.302z"
    }, null, -1)
  ]))]))
}
export default { render: render }